import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=fda7ce0e&scoped=true&"
import script from "./Matrix.js?vue&type=script&lang=js&"
export * from "./Matrix.js?vue&type=script&lang=js&"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=fda7ce0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda7ce0e",
  null
  
)

export default component.exports